import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({userid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    if (!userid || !setLoading) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/order-list.php?userid=${userid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{ 
        setLoading(false);
      }
      
    };

    fetchData();
  }, [userid, setLoading]);

  return {data};
};

export default useFetchData;